import { useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";

const IdleTimer = ({ timeout = 3600000 }) => { // Default set to 60,000ms (1 minute)
// const IdleTimer = ({ timeout = 1000 }) => { // Default set to 60,000ms (1 minute)

  const timerRef = useRef(null);
  const navigate = useNavigate();

  const logoutUser = useCallback(() => {
    // console.log("!!! User inactive for 1 minute. Logging out now !!!");
    
    // Clear all storage
    sessionStorage.clear();
    localStorage.clear();
    
    // Redirect to login
    navigate("/auth");
  }, [navigate]);

  const resetTimer = useCallback(() => {
    // Clear the existing pending logout
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    // Schedule a new logout
    // console.log("Activity detected. Timer reset to 60 seconds.");
    timerRef.current = setTimeout(logoutUser, timeout);
  }, [timeout, logoutUser]);

  useEffect(() => {
    const events = ["mousemove", "keydown", "mousedown", "touchstart"];

    // Add event listeners for activity
    events.forEach((event) => window.addEventListener(event, resetTimer));

    // Handle when user switches back to this tab
    const handleVisibilityChange = () => {
      if (!document.hidden) resetTimer();
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Initial start: Start the countdown as soon as the component loads
    timerRef.current = setTimeout(logoutUser, timeout);

    return () => {
      // Cleanup: stop timer and remove listeners when component unmounts
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [resetTimer, timeout, logoutUser]);

  return null;
};

export default IdleTimer;